import React from 'react';
import styled from 'styled-components';
import Dialog from '@/presentation/reusables/Dialog';
import DialogExtraCaption from '@/presentation/reusables/Dialog/extras/caption';

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: 16px;
`;

interface IProps {
  img?: string;
  data: any;
  handlerClick: () => void;
  handlerClose: () => void;
  show: boolean;
}

const MyModal = ({ img, data, handlerClick, handlerClose, show }: IProps) => (
  <Dialog
    handlerButtonA={() => handlerClick()}
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    textButtonA="Entendido"
    zIndex={1000}
    persistence
  >
    {img && (
      <ImageContainer>
        <img src={img} alt="imgCoverLetter" />
      </ImageContainer>
    )}
    <DialogExtraCaption
      subtitle={data.description}
      title={data.title}
      subtitle2={data.description2}
    />
  </Dialog>
);

export default MyModal;
